angular.module('bmsApp.sm.job')
	.controller('SMJobCloseCtrl', [
		'$state',
		'$scope',
		'$q',
		'notify',
		'$ngBootbox',
		'AccountingSvc',
		'EmployeeSvc',
		'SMCleaningServiceSvc',
		'SMJobSvc',
		'TaxHelperSvc',
		'SMMaterialTestPhotoSvc',
		'RecentPaymentSvc',
		function ($state,
				  $scope,
				  $q,
				  notify,
				  $ngBootbox,
				  AccountingSvc,
				  EmployeeSvc,
				  SMCleaningServiceSvc,
				  SMJobSvc,
				  TaxHelperSvc,
				  SMMaterialTestPhotoSvc,
					RecentPaymentSvc) {

			function init() {
				self.loading = true;
				var employeeParams = {
					filter: {}
				};
				var promises = {
					job: SMJobSvc.read($state.params.jobId)
						.then(function (response) {
							self.job = response.data.sm_job;
							if (!self.job.closed) {
								self.job.send_sms_feedback = true;
								if(self.job.send_sms_feedback == false){
									self.job.send_cstomise_message = false;
									self.job.cstomise_message = null;
								}
								// self.job.completed = true;
								angular.forEach(self.job.visits, function(visit) {
									if (angular.isArray(visit.visit_employees)) {
										angular.forEach(visit.visit_employees, function (visitEmployee) {
											if(visitEmployee.started_at == null && visitEmployee.ended_at == null){
												visitEmployee.hours = self.job.hours;
												visitEmployee.minutes = self.job.minutes;
											}
										});
									}
								});
							}
							self.job.additional_cleaning_services = self.job.additional_cleaning_services || [];
							self.job.customer_payments = self.job.customer_payments || [];

							$scope.$emit('closeJobUpdated', {
								job: self.job
							});
						}),
					jobCancelReasons: SMJobSvc.cancelReason.options()
						.then(function (response) {
							self.form.options.jobCancelReason = response.data.options;
						}),
					employees: EmployeeSvc.index(employeeParams)
						.then(function (response) {
							self.employees = response.data.employee_collection;
						}),
					getVatRate: TaxHelperSvc.getVatRate()
						.then(function (vatRate) {
							self.vatRate = vatRate;
						}),
					discountTypes: SMJobSvc.discountType.options()
						.then(function (response) {
							self.form.options.discountType = response.data.options;
						})
				};
				$q.all(promises)
					.finally(function () {
						self.loading = false;
					});
			}

			function addVisitEmployee(visit) {
				// if (!angular.isArray(visit.employees)) {
				// 	angular.extend(visit, {
				// 		employees: []
				// 	});
				// }

				visit.visit_employees.push({
					employee: null,
					hours: self.job.hours,
					minutes: self.job.minutes
				});
			}

			function removeVisitEmployee(visit, visitEmployee) {
				if (visitEmployee.id) {
					if (!visitEmployee.scheduled) {
						visitEmployee.delete = true;
					}
				}
				else {
					visit.visit_employees.splice(visit.visit_employees.indexOf(visitEmployee), 1);
				}
			}

			function addCleaningService() {
				if (self.job.closed === false) {
					console.info('self.job.license_id', self.job.license_id);
					SMCleaningServiceSvc.showCleaningServiceModal(null, self.job.license_id)
						.then(function (result) {
							angular.extend(result.cleaningService, {
								additional: true,
								accepted: true,
								satisfied: true,
							});

							self.job.additional_cleaning_services.push(result.cleaningService);
							validatePaymentAllocation();

							console.info(self.job.additional_cleaning_services);
						});
				}
			}

			function editCleaningService(item) {
				if (self.job.closed === false) {
					SMCleaningServiceSvc.showCleaningServiceModal(item, self.job.license_id)
						.then(function (result) {
							angular.extend(item, result.cleaningService);
							validatePaymentAllocation();
						});
				}
			}

			function deleteCleaningService(item) {
				if (self.job.closed === false) {
					if (item.id) {
						item.delete = true
					}
					else {
						self.job.additional_cleaning_services.splice(self.job.additional_cleaning_services.indexOf(item), 1);
					}
					// calculateEstimatedJobDuration();
					validatePaymentAllocation();
				}
			}


			function showMaterialTestPhotos(jobCleaningService) {
				SMCleaningServiceSvc.showMaterialTestPhotosModal(jobCleaningService, null)
					.then(function (result) {
					});
			}

			function undoDeleteCleaningService(item) {
				angular.extend(item, {
					delete: false
				});
			}

			function allocateCustomerPayment() {
				if (self.job.closed === false) {
					var invoicePrototype;
					var additionalInvoicePrototype;
					var discountedInvoice;
					if (self.job.preinvoice) {
						// invoicePrototype = angular.extend(angular.copy(self.job.preinvoice), {
						// 	invoice_number: 'This Invoice'
						// });
					}
					else {
						invoicePrototype = {
							invoice_number: 'This Invoice',
							invoice_date: self.job.last_visit_date,
							total_net: 0,
							total_vat: 0,
							total_gross: 0,
							amount_paid: 0,
							outstanding: 0
						};
					}

					if (self.job.preinvoice && self.job.additional_cleaning_services.length) {
						additionalInvoicePrototype = {
							invoice_number: 'Additional Invoice',
							invoice_date: self.job.last_visit_date,
							total_net: 0,
							total_vat: 0,
							total_gross: 0,
							amount_paid: 0,
							outstanding: 0
						};
					}

					if (angular.isObject(invoicePrototype)) {
						discountedInvoice = invoicePrototype;
					}
					else if(angular.isObject(additionalInvoicePrototype)) {
						discountedInvoice = additionalInvoicePrototype;
					}

					if (!self.job.preinvoice) {
						// add scheduled cleaning services only if not preinvoiced
						angular.forEach(self.job.scheduled_cleaning_services, function (jobCleaningService) {
							if (jobCleaningService.delete !== true && jobCleaningService.accepted) {
								invoicePrototype.total_net += csGetDiscountedNet(jobCleaningService);
								invoicePrototype.total_vat += csGetDiscountedVat(jobCleaningService);
								invoicePrototype.total_gross += csGetDiscountedGross(jobCleaningService);
							}
						});
						invoicePrototype.outstanding = invoicePrototype.total_gross;
					}

					// add additional work and job discount to additional prototype if preinvoiced, else first prototype
					var addAdditionalTo = angular.isObject(additionalInvoicePrototype) ? additionalInvoicePrototype : invoicePrototype;
					if (self.job.additional_cleaning_services.length) {
						console.log(addAdditionalTo.total_net, addAdditionalTo.total_vat, addAdditionalTo.total_gross, '------');
						angular.forEach(self.job.additional_cleaning_services, function (jobCleaningService) {
							if(jobCleaningService.accepted){
								addAdditionalTo.total_net += csGetDiscountedNet(jobCleaningService);
								addAdditionalTo.total_vat += csGetDiscountedVat(jobCleaningService);
								addAdditionalTo.total_gross += csGetDiscountedGross(jobCleaningService);
								console.log(addAdditionalTo.total_net, addAdditionalTo.total_vat, addAdditionalTo.total_gross);
							}
							console.log(jobCleaningService, addAdditionalTo, '-------');
						});
						console.log(addAdditionalTo.total_net, addAdditionalTo.total_vat, addAdditionalTo.total_gross);
						addAdditionalTo.outstanding = addAdditionalTo.total_gross;
					}
					if (angular.isObject(self.job.discount_type) && angular.isObject(discountedInvoice)) {
						if (self.job.discount_type.value === 'percent') {
							discountedInvoice.total_gross -= discountedInvoice.total_gross * (parseFloat(self.job.discount_value) || 0) / 100;
						}
						if (self.job.discount_type.value === 'flat') {
							discountedInvoice.total_gross -= parseFloat(self.job.discount_value);
						}
						discountedInvoice.total_net = TaxHelperSvc.netFromGross(discountedInvoice.total_gross);
						discountedInvoice.total_vat = TaxHelperSvc.vatFromGross(discountedInvoice.total_gross);
						discountedInvoice.outstanding = discountedInvoice.total_gross;
					}

					// adjust customer's balance by the customer payments on this page
					var balanceAdjustment = 0;
					angular.forEach(self.job.customer_payments, function (customerPayment) {
						balanceAdjustment += customerPayment.received_amount;
					});
					self.job.customer.balance_adjustment = balanceAdjustment;
					AccountingSvc.showPaymentReceiptModal(self.job.customer, invoicePrototype, additionalInvoicePrototype)
						.then(function (modalResult) {
							self.job.customer_payments.push(modalResult.customerPayment);
							validatePaymentAllocation();
						});
				}
			}

			function removeCustomerPayment(customerPayment) {
				if (self.job.closed === false) {
					$ngBootbox.confirm('Are you sure you want to remove this customer payment?')
						.then(function () {
							self.job.customer_payments.splice(self.job.customer_payments.indexOf(customerPayment), 1);
							validatePaymentAllocation();
						});
				}
			}

			function validatePaymentAllocation() {
				var amountAllocated = 0;
				angular.forEach(self.job.customer_payments, function (customerPayment) {
					angular.forEach(customerPayment.invoices, function (invoice) {
						if ((self.job.preinvoice && invoice.id == self.job.preinvoice.id) || !invoice.id) {
							amountAllocated += parseFloat(invoice.allocation);
						}
					})
				});
				self.invoicePaymentOverAllocated = !(amountAllocated - summaryDiscountedGrandTotalGross() < 0.005);

				return !self.invoicePaymentOverAllocated;
			}

			function validateDisclaimerReason(cleaningServices) {
				var allValid = true;
				angular.forEach(cleaningServices, function (cleaningService) {
					if (!cleaningService.accepted && (cleaningService.disclaimer_reason == '' || !cleaningService.disclaimer_reason)) {
						allValid = false;
					}
				});
				if(!allValid){
					notify({
						message: 'Please update disclaimer reason',
						class: 'error',
					});
				}
				return allValid;
			}

			function hasNotAcceptedCleaningService() {
				var notAcceptedCleaningService = 0;
				angular.forEach(self.job.scheduled_cleaning_services, function (cleaningService) {
					if (!cleaningService.accepted) {
						notAcceptedCleaningService++;
					}
				});
				return notAcceptedCleaningService == 0 ? false : true;
			}

			function csGetDiscountedNet(jobCleaningService) {
				return SMCleaningServiceSvc.calcDiscountedNet(jobCleaningService);
			}

			function csGetDiscountedVat(jobCleaningService) {
				return SMCleaningServiceSvc.calcDiscountedVat(jobCleaningService);
			}

			function csGetDiscountedGross(jobCleaningService) {
				return SMCleaningServiceSvc.calcDiscountedGross(jobCleaningService);
			}

			function summaryDiscountedSubtotalNet() {
				var retVal = 0;
				angular.forEach(self.job.scheduled_cleaning_services, function (jobCleaningService) {
					if (!jobCleaningService.delete && jobCleaningService.accepted) {
						retVal += csGetDiscountedNet(jobCleaningService) || 0;
					}
				});
				angular.forEach(self.job.additional_cleaning_services, function (jobCleaningService) {
					if (jobCleaningService.accepted) {
						retVal += csGetDiscountedNet(jobCleaningService) || 0;
					}
				});

				return retVal;
			}

			function summaryDiscountedSubtotalVat() {
				var retVal = 0;
				angular.forEach(self.job.scheduled_cleaning_services, function (jobCleaningService) {
					if (!jobCleaningService.delete && jobCleaningService.accepted) {
						retVal += csGetDiscountedVat(jobCleaningService) || 0;
					}
				});
				angular.forEach(self.job.additional_cleaning_services, function (jobCleaningService) {
					if(jobCleaningService.accepted){
						retVal += csGetDiscountedVat(jobCleaningService) || 0;
					}
				});

				return retVal;
			}

			function summaryDiscountedSubtotalGross() {
				var retVal = 0;
				angular.forEach(self.job.scheduled_cleaning_services, function (jobCleaningService) {
					if (!jobCleaningService.delete && jobCleaningService.accepted) {
						retVal += csGetDiscountedGross(jobCleaningService) || 0;
					}
				});
				angular.forEach(self.job.additional_cleaning_services, function (jobCleaningService) {
					if(jobCleaningService.accepted){
						retVal += csGetDiscountedGross(jobCleaningService) || 0;
					}
				});

				return retVal;
			}

			function summaryDiscountedGrandTotalNet() {
				var grandNet = summaryDiscountedSubtotalNet();

				if (angular.isObject(self.job.discount_type) && (parseFloat(self.job.discount_value) || 0) !== 0) {
					// only recalculate VAT if there is a discount
					grandNet = TaxHelperSvc.netFromGross(summaryDiscountedGrandTotalGross());
				}

				return grandNet;
			}

			function summaryDiscountedGrandTotalVat() {
				var grandVat = summaryDiscountedSubtotalVat();

				if (angular.isObject(self.job.discount_type) && (parseFloat(self.job.discount_value) || 0) !== 0) {
					// only recalculate VAT if there is a discount
					grandVat = TaxHelperSvc.vatFromGross(summaryDiscountedGrandTotalGross());
				}

				return grandVat;
			}

			function summaryDiscountedGrandTotalGross() {
				var grandGross = summaryDiscountedSubtotalGross();

				if (angular.isObject(self.job.discount_type)) {
					var discountType = self.job.discount_type;
					if (discountType.value === 'percent') {
						grandGross -= grandGross * (parseFloat(self.job.discount_value) || 0) / 100;
					}
					if (discountType.value === 'flat') {
						grandGross -= parseFloat(self.job.discount_value) || 0;
					}
				}

				return grandGross;
			}

			function summaryDiscountNet() {
				return TaxHelperSvc.netFromGross(summaryDiscountGross());
			}

			function summaryDiscountVat() {
				return TaxHelperSvc.vatFromGross(summaryDiscountGross());
			}

			function summaryDiscountGross() {
				var subGross = summaryDiscountedSubtotalGross();
				var discountGross = 0;

				if (angular.isObject(self.job.discount_type)) {
					var discountType = self.job.discount_type;
					if (discountType.value === 'percent') {
						discountGross = subGross * (parseFloat(self.job.discount_value) || 0) / 100;
					}
					if (discountType.value === 'flat') {
						discountGross = parseFloat(self.job.discount_value) || 0;
					}
				}

				return discountGross;
			}

			function discountTypeUpdated() {
				var job = self.job;
				if (!angular.isObject(job.discount_type)) {
					job.discount_value = 0;
					job.discount_description = '';
				}
			}

			$scope.sendFeedback = function(){
				self.job.send_cstomise_message = false;
				self.job.cstomise_message = null;
			}

			function submit() {
				if (self.form.validator.api.valid() && validatePaymentAllocation() && validateDisclaimerReason(self.job.scheduled_cleaning_services) && validateDisclaimerReason(self.job.additional_cleaning_services)) {
					$ngBootbox.confirm('Are you sure you want to close this job?')
						.then(function () {
							self.form.submitted = true;
							self.form.promise = SMJobSvc.close(self.job)
								.then(function () {
									notify({
										message: self.job.closed ? 'Close job successfully updated' : 'Job successfully closed'
									});
									$state.go('main.sm.job.closeJobList');
								}, function (errors) {
									self.errors = errors;
								})
								.finally(function () {
									self.form.submitted = false;
								});
						});
				}
			}

			function recentPayments(){
				RecentPaymentSvc.showRecentPaymentModal(self.job.customer);
			}

			var self = $scope.SMJobCloseCtrl = {
				loading: false,
				job: {},
				methods: {
					init: init,
					addVisitEmployee: addVisitEmployee,
					removeVisitEmployee: removeVisitEmployee,
					addCleaningService: addCleaningService,
					editCleaningService: editCleaningService,
					deleteCleaningService: deleteCleaningService,
					undoDeleteCleaningService: undoDeleteCleaningService,
					allocateCustomerPayment: allocateCustomerPayment,
					removeCustomerPayment: removeCustomerPayment,
					showMaterialTestPhotos: showMaterialTestPhotos,
					summaryDiscountedSubtotalNet: summaryDiscountedSubtotalNet,
					summaryDiscountedSubtotalVat: summaryDiscountedSubtotalVat,
					summaryDiscountedSubtotalGross: summaryDiscountedSubtotalGross,
					summaryDiscountNet: summaryDiscountNet,
					summaryDiscountVat: summaryDiscountVat,
					summaryDiscountGross: summaryDiscountGross,
					summaryDiscountedGrandTotalNet: summaryDiscountedGrandTotalNet,
					summaryDiscountedGrandTotalVat: summaryDiscountedGrandTotalVat,
					summaryDiscountedGrandTotalGross: summaryDiscountedGrandTotalGross,
					submit: submit,
					discountTypeUpdated: discountTypeUpdated,
					hasNotAcceptedCleaningService: hasNotAcceptedCleaningService,
					jobCleaningService: {
						getDiscountedNet: csGetDiscountedNet,
						getDiscountedVat: csGetDiscountedVat,
						getDiscountedGross: csGetDiscountedGross
					},
					recentPayments :recentPayments
				},
				form: {
					options: {},
					validator: {
						config: {
							errorPlacement: function (error) {
								error.appendTo('#form-errors');
							},
							errorContainer: '#form-errors'
						},
						api: {}
					},
					promise: undefined
				}
			};

		}
	]);
